<div class="login">
  <div class="login__header">
    <img src="../assets/natura-logo.svg" class="login__logo"/>
  </div>
  <div class="login__content">
    <mat-card class="box">
      <mat-card-header>
        <div align="center">
          <h2>Restablecer Contraseña</h2>
        </div>
      </mat-card-header>
      <mat-card-content>
        <form class="example-form">
          <mat-form-field class="example-full-width">
            <input matInput [(ngModel)]="pass" name="pass" type="password" id="inputPassword" (click)="hideTooltip=!hideTooltip;" (blur)="hideTooltip=false;"
              name="password" [type]="hide ? 'password' : 'text'" placeholder="Nueva contraseña" tabindex="1" required>
            <mat-icon class="placeholder" (click)="myFunction()" >{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </mat-form-field>
          <mat-form-field class="example-full-width">
            <input matInput placeholder="Repita nueva contraseña" [(ngModel)]="passConfirm" name="passConfirm"
              type="password" [type]="hide ? 'password' : 'text'" tabindex="2" required>
            <mat-icon class="placeholder" (click)="myFunction()">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </mat-form-field>
        </form>
      </mat-card-content>
      <div class="hint-box" [ngClass]="{'is-visible':hideTooltip, 'hint-box--big-list': (listRule.passwordPolicies ? listRule.passwordPolicies.length : 0) + (listRule.passwordRestrictions ? listRule.passwordRestrictions.length : 0) > 5}">
        <div *ngIf="listRule.passwordPolicies.length > 0"> 
          <h2 class="hint-box__title">Su contraseña debe contener...</h2>
          <ul class="hint-box__list">
            <li class="hint-box__list__item" *ngFor="let item of listRule.passwordPolicies; let i = index">{{item}}</li>
          </ul>
        </div>
        <div *ngIf="listRule.passwordRestrictions.length > 0 || listRule.passwordForbiddenWords.length > 0"> 
          <h2 class="hint-box__title">Su contraseña NO debe contener...</h2>
          <ul class="hint-box__list">
            <li class="hint-box__list__item" *ngFor="let item of listRule.passwordRestrictions; let i = index">{{item}}</li>
            <li class="hint-box__list__item" >{{restrictWords}}</li>
          </ul>
        </div>
      </div>
    </mat-card>
  </div>
  <div class="login__actions">
    <button mat-stroked-button color="" (click)="openDialog()" class="button-send"
      [disabled]="pass == '' || passConfirm == '' ? true : false" tabindex="3">
      ENVIAR
    </button>
  </div>
  <div class="login__footer">
    <img src="../assets/powered by Gera.svg" width="100%" style="max-width: 150px; position: relative;" />
  </div>
</div>